import React from 'react';
import './Grafibjm.css';
import BJMplaten from '../../../imgs/BJMplaten.webp'; 

const Grafibjm = () => {
  return (
    <div className="Grafi-container"data-aos="fade-down" >
      <img src={BJMplaten} alt="Fitting Corrosion" className="Grafi-image" />
    </div>
  );
};

export default Grafibjm;
